import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints } from '@/styles'
import useMediaQuery from '@/hooks/use-media-query'
import TestimonialCard from '@/components/testimonial-card'
import { useLandlordTestimonials } from '@/components/testimonials'

import { SectionHeading } from './elements'

const Section = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Grid = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column wrap;
  align-content: space-between;
  gap: 16px;
  height: 540px;

  > div {
    width: 32%;
  }

  @media (max-width: 1400px) {
    height: 575px;
  }

  @media (max-width: ${breakpoints.v3Desktop}) {
    height: 620px;
  }

  @media (max-width: ${breakpoints.desktop}) {
    height: auto;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    align-items: stretch;

    > div {
      width: 100%;
    }
  }

  @media (max-width: ${breakpoints.ipadMiniMax}) {
    grid-template-columns: 1fr;
    gap: 16px;
    align-items: start;
  }
`

const TestimonialsSection = () => {
  const { t } = useTranslation('pricing')
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)
  const landlordTestimonials = useLandlordTestimonials()
  const COUNT = displayMobile ? 3 : 6

  return (
    <Section>
      <SectionHeading>
        {t(`pricing:We're changing the way Canada rents`)}
      </SectionHeading>
      <Grid>
        {landlordTestimonials.map((testimonial, index) => {
          return index < COUNT ? (
            <TestimonialCard
              key={testimonial.name}
              avatar={testimonial.avatar}
              name={testimonial.name}
              company={testimonial.company}
              companyLink={testimonial.companyLink}
              review={testimonial.reviewCondensed}
            />
          ) : null
        })}
      </Grid>
    </Section>
  )
}

export default TestimonialsSection
